(function () {
  if (customElements.get('imoco-hero-slider')) return;
  class ImocoHeroSlider extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.slides = Array.from(this.querySelectorAll('.imoco-hero__slide'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
      this.observer.observe(this);
      this.visibilityHandler = () => this.sync();
      this.motionHandler = () => this.sync();
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.motion.addEventListener('change', this.motionHandler);
      this.sync();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    }
    sync() {
      clearInterval(this.timer);
      if (this.dataset.autoplay === 'true' && this.visible && !document.hidden && !this.motion.matches) {
        this.timer = setInterval(() => this.show(this.index + 1), 7000);
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.observer) this.observer.disconnect();
      if (this.visibilityHandler) document.removeEventListener('visibilitychange', this.visibilityHandler);
      if (this.motion) this.motion.removeEventListener('change', this.motionHandler);
      this.bound = false;
    }
  }
  customElements.define('imoco-hero-slider', ImocoHeroSlider);
}());
